module.exports = __webpack_public_path__ + "static/media/expo.3b04e00b.png";